import { t } from 'i18next';

import { bundlesEndpoints } from '@/api/endpoints';

import { debouncedCheckNameAvailability } from '../../debouncedCheckNames';
import { LENGTH_XS, LENGTH_M, LENGTH_S } from '../constants';
import { slug } from '../patterns';

export const accountRules = { name: { required: true, maxLength: LENGTH_XS } };

export const intentRules = {
  name: { required: true, pattern: slug, minLength: 2, maxLength: LENGTH_S },
  description: { required: false, maxLength: LENGTH_M },
};

export const dialogRules = {
  name: { required: true, maxLength: 45, minLength: 2 },
  description: { required: false, maxLength: LENGTH_M },
};

export const entityRules = {
  name: { required: true, pattern: slug, minLength: 2, maxLength: LENGTH_S },
  description: { required: false, maxLength: LENGTH_M },
};

export const bundleRules = (deskId: string, currentName?: string) => ({
  name: {
    required: true,
    maxLength: LENGTH_XS,
    validate: {
      uniqueName: async (value: string) => {
        if (!value?.trim()) {
          return true;
        }

        // Skip validation if the name hasn't changed
        if (currentName && value.trim().toLowerCase() === currentName.toLowerCase()) {
          return true;
        }

        try {
          const endpoint = bundlesEndpoints.checkName(deskId, value.trim(), { desk_id: deskId });
          const { available } = await debouncedCheckNameAvailability(endpoint);
          return available || t('validation.name_already_exists');
        } catch (error) {
          return error?.message || t('validation.error_checking_name');
        }
      },
    },
  },
  description: { required: false, maxLength: LENGTH_M },
});

export const nodeRules = {
  name: { required: true, maxLength: LENGTH_XS },
  intent: { pattern: slug, required: true },
};
